(function () {
  if (window.__havinReels) return;
  window.__havinReels = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function playSafe(v) {
    if (!v) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* ---------- Rail: arrows + play the most visible card (muted) ---------- */
  function initRail(section) {
    if (section.__hr) return;
    section.__hr = true;
    var track = section.querySelector('.havin-reels__track');
    var prev = section.querySelector('.havin-reels__nav--prev');
    var next = section.querySelector('.havin-reels__nav--next');
    function step(dir) {
      var card = track.querySelector('.havin-reel');
      var w = card ? card.getBoundingClientRect().width + 14 : 260;
      track.scrollBy({ left: dir * w * 2, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function navState() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', navState, { passive: true });
    window.addEventListener('resize', navState);
    navState();

    track.querySelectorAll('.havin-reel').forEach(function (li, i) {
      li.querySelector('.havin-reel__open').addEventListener('click', function () { openViewer(section, i); });
    });

    var videos = Array.prototype.slice.call(track.querySelectorAll('.havin-reel__video'));
    videos.forEach(function (v) {
      var li = v.closest('.havin-reel');
      v.addEventListener('playing', function () { li.classList.add('is-playing'); });
      v.addEventListener('pause', function () { li.classList.remove('is-playing'); });
    });

    if (section.dataset.autoplay !== 'true' || reduceMotion || !('IntersectionObserver' in window)) return;
    var visible = new Set();
    function resume() {
      if (document.hidden || viewerOpen()) return;
      visible.forEach(function (v) { v.preload = 'auto'; playSafe(v); });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.intersectionRatio >= 0.5) { visible.add(e.target); } else { visible.delete(e.target); e.target.pause(); }
      });
      resume();
    }, { threshold: [0, 0.5, 1] });
    videos.forEach(function (v) { io.observe(v); });
    section.__resume = resume;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) videos.forEach(function (v) { v.pause(); }); else resume();
    });
  }

  function viewerOpen() {
    return !!(viewer && (viewer.open || viewer.hasAttribute('open')));
  }

  function resumeRails() {
    document.querySelectorAll('.havin-reels').forEach(function (s) { if (s.__resume) s.__resume(); });
  }

  /* ---------- Full-screen viewer ---------- */
  var viewer, viewerList, muted = true;

  function buildViewer() {
    viewer = document.createElement('dialog');
    viewer.className = 'havin-reels-viewer';
    viewer.setAttribute('aria-label', 'Reels');
    viewer.innerHTML =
      '<button type="button" class="hrv__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="hrv__sound" aria-label="Unmute">&#128263;</button>' +
      '<div class="hrv__list"></div>';
    document.body.appendChild(viewer);
    viewerList = viewer.querySelector('.hrv__list');
    viewer.querySelector('.hrv__close').addEventListener('click', closeViewer);
    viewer.addEventListener('cancel', function (e) { e.preventDefault(); closeViewer(); });
    viewer.addEventListener('click', function (e) { if (e.target === viewer) closeViewer(); });
    viewer.querySelector('.hrv__sound').addEventListener('click', function () {
      muted = !muted;
      this.innerHTML = muted ? '&#128263;' : '&#128264;';
      this.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
      viewerList.querySelectorAll('video').forEach(function (v) { v.muted = muted; });
    });
    viewer.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        viewerList.scrollBy({ top: (e.key === 'ArrowDown' ? 1 : -1) * viewerList.clientHeight, behavior: 'smooth' });
      }
    });
    viewerList.addEventListener('click', onAdd);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target.querySelector('video');
        if (e.intersectionRatio > 0.7) { v.muted = muted; playSafe(v); } else { v.pause(); }
      });
    }, { root: viewerList, threshold: [0, 0.7] });
    viewer.__io = io;
  }

  function openViewer(section, index) {
    if (!viewer) buildViewer();
    document.querySelectorAll('.havin-reel__video').forEach(function (v) { v.pause(); });
    viewerList.innerHTML = '';
    section.querySelectorAll('.havin-reel').forEach(function (li) {
      var slide = document.createElement('div');
      slide.className = 'hrv__slide';
      var src = li.querySelector('.havin-reel__video');
      var v = document.createElement('video');
      v.playsInline = true; v.loop = true; v.muted = muted; v.preload = 'metadata';
      v.setAttribute('playsinline', '');
      if (src.poster) v.poster = src.poster;
      var sources = Array.prototype.slice.call(src.querySelectorAll('source'));
      sources.sort(function (a, b) { return Math.abs((+a.dataset.height || 0) - 1280) - Math.abs((+b.dataset.height || 0) - 1280); });
      if (sources[0]) v.src = sources[0].src;
      v.addEventListener('click', function () { v.paused ? playSafe(v) : v.pause(); });
      slide.appendChild(v);
      var info = document.createElement('div');
      info.className = 'hrv__info';
      var tpl = li.querySelector('template.havin-reel__data');
      if (tpl) info.appendChild(tpl.content.cloneNode(true));
      slide.appendChild(info);
      viewerList.appendChild(slide);
      viewer.__io.observe(slide);
    });
    if (viewer.showModal) viewer.showModal(); else viewer.setAttribute('open', '');
    document.documentElement.classList.add('hrv-lock');
    var target = viewerList.children[index];
    if (target) {
      viewerList.scrollTop = target.offsetTop;
      playSafe(target.querySelector('video'));
    }
  }

  function closeViewer() {
    viewerList.querySelectorAll('video').forEach(function (v) { v.pause(); v.removeAttribute('src'); v.load(); });
    viewerList.innerHTML = '';
    if (viewer.close) viewer.close(); else viewer.removeAttribute('open');
    document.documentElement.classList.remove('hrv-lock');
    resumeRails();
  }

  function onAdd(e) {
    var btn = e.target.closest('button.havin-reel__add');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = '…';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch(root + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'havin-reels', data: { source: 'havin-reels', itemCount: cart.item_count } }
        }));
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .header-actions__cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2000);
      })
      .catch(function () { btn.textContent = 'Retry'; btn.disabled = false; });
  }

  function boot() {
    document.querySelectorAll('.havin-reels').forEach(initRail);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
